import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Col, Row } from "styles";
import { Table } from "../../style";

export function Organics(props) {
  return (
    <>
      <Row>
        <Col>
          <div
            style={{
              textAlign: "end",
              marginRight: "40px",
            }}
          >
            <Input
              type="checkbox"
              params="minerals.organics.unknownConcept"
              item={props.megg}
              setItem={props.setMegg}
              label="Cliente não conhece o conceito"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table>
            <Header>
              <tr>
                <th style={{ width: "185px" }}>
                  <span></span>
                </th>
                <th>
                  <span>Qual Produto?</span>
                </th>
                <th>
                  <span>Qual Finalidade?</span>
                </th>
              </tr>
            </Header>
            <Body>
              <tr>
                <td>Pré</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="minerals.organics.pre.product"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="minerals.organics.pre.reason"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
              <tr>
                <td>Inicial</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="minerals.organics.initial.product"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="minerals.organics.initial.reason"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
              <tr>
                <td>Crescimento</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="minerals.organics.growth.product"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="minerals.organics.growth.reason"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
              <tr>
                <td>Desenvolvimento</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="minerals.organics.development.product"
                    item={props.megg}
                    setItem={props.setMegg}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="minerals.organics.development.reason"
                    item={props.megg}
                    setItem={props.setMegg}
                  />
                </td>
              </tr>
            </Body>
          </Table>
        </Col>
      </Row>
    </>
  );
}
